import React from 'react';
import { Inbox } from 'lucide-react';

export default function SettingsEmptyState({
  title,
  description,
  icon: Icon = Inbox,
  action,
  testId,
}) {
  return (
    <div className="rounded-xl border border-dashed border-stone-300 bg-stone-50 px-4 py-7 text-center" data-testid={testId}>
      <Icon className="mx-auto mb-2 h-7 w-7 text-stone-300" aria-hidden="true" />
      <div className="text-sm font-semibold text-stone-700">{title}</div>
      {description && <div className="mx-auto mt-1 max-w-md text-xs text-stone-500">{description}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}